import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

type IDncApiResponse = {
  isDNC: boolean;
};

export const getDncStatus = async (mobileNo: string): Promise<IResponse<IDncApiResponse>> => {
  const response = await encryptedRequest<IDncApiResponse>({
    method: "POST",
    url: API_PATHS.dncStatus,
    data: {
      mobileNo,
    },
  });

  return response;
};
